<template>
  <div class="rating-block">
    <ul class="rating__list">
      <li
        v-for="index in Math.round(rating)"
        :key="index"
        class="rating__item"
      >
        <RatingStarIcon />
      </li>
    </ul>
  </div>
</template>

<script>
import { RatingStarIcon } from '@/shared/ui/icons';

export default {
  props: {
    rating: {
      type: Number,
      default: 0,
    },
  },
  components: { RatingStarIcon },
};
</script>

<style scoped lang="scss">
.rating-block {
  display: flex;
  justify-content: center;
}

.rating {
  &__list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>
